import { Route, Routes } from 'react-router-dom';
import HomePage from './homePage';

const IntroRouter = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </>
  );
};

export default IntroRouter;
